import React, { useState, useCallback } from 'react'
import { Layout } from 'components'
import userInfo from 'utils/userInfo'
import styles from './EmployeeCard.module.scss'

import ProfileCard    from './components/ProfileCard/ProfileCard'
import DocflowBanner  from './components/DocflowBanner/DocflowBanner'
import DocPreviewModal from './components/DocPreviewModal/DocPreviewModal'

import MyDocsTab      from './tabs/MyDocsTab/MyDocsTab'
import DeptTab        from './tabs/DeptTab/DeptTab'
import TransitTab     from './tabs/TransitTab/TransitTab'
import KyrgyzkomurTab from './tabs/KyrgyzkomurTab/KyrgyzkomurTab'
import NPATab         from './tabs/NPATab/NPATab'
import { downloadDocument, downloadNPA } from 'service/KomurConnectionService'

const TABS = [
  { key: 'my',          label: 'Мои документы' },
  { key: 'dept',        label: 'Отдел' },
  { key: 'transit',     label: 'Транзит' },
  { key: 'kyrgyzkomur', label: 'Кыргызкомур' },
  { key: 'npa',         label: 'НПА' },
]

export default function EmployeeCard() {
  const user = userInfo()
  const [tab,        setTab]        = useState('my')
  const [previewDoc, setPreviewDoc] = useState(null)

  const handlePreview       = useCallback((doc) => setPreviewDoc(doc), [])
  const handleClosePreview  = useCallback(() => setPreviewDoc(null), [])

  const handlePreviewDownload = useCallback(() => {
    if (!previewDoc) return
    const isNpa = !('is_open' in previewDoc)
    const fn = isNpa ? downloadNPA : downloadDocument
    fn(previewDoc.id).then(r => {
      const a = document.createElement('a')
      a.href = r.data.file_url
      a.download = previewDoc.file_name || 'document'
      a.click()
    }).catch(() => {})
  }, [previewDoc])

  const renderTab = () => {
    switch (tab) {
      case 'my':          return <MyDocsTab      onPreview={handlePreview} />
      case 'dept':        return <DeptTab         onPreview={handlePreview} />
      case 'transit':     return <TransitTab      onPreview={handlePreview} />
      case 'kyrgyzkomur': return <KyrgyzkomurTab  onPreview={handlePreview} />
      case 'npa':         return <NPATab          onPreview={handlePreview} />
      default:            return null
    }
  }

  return (
    <Layout>
      <div className={styles.page}>
        <div className={styles.wrap}>

          <ProfileCard user={user} />

          <DocflowBanner />

          <div className={styles.tabs}>
            {TABS.map(t => (
              <button
                key={t.key}
                className={`${styles.tabBtn} ${tab === t.key ? styles.tabActive : ''}`}
                onClick={() => setTab(t.key)}
              >
                {t.label}
              </button>
            ))}
          </div>

          <div className={styles.tabContent}>
            {renderTab()}
          </div>

        </div>
      </div>

      {previewDoc && (
        <DocPreviewModal
          doc={previewDoc}
          onClose={handleClosePreview}
          onDownload={handlePreviewDownload}
        />
      )}
    </Layout>
  )
}
